import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../hooks/useWindowResize";
import { size } from "../../../constants";
import ContactSectionForm from "../../../components/ContactSectionForm";
import styled from "styled-components";

/* home-scoped v2 overrides: keep the continuous #000104 canvas so the shared
   form section blends with the rest of the redesigned page */
const StylesWrapper = styled.div`
  .contact-wrapper {
    .container-blog {
      max-width: unset;
    }

    section {
      background: #000104;
    }

    /* match the shared HeadV2 section heading used by every other home
       section (Blog, DNA, Cases…) — the form's default title is lighter
       and smaller, which read as out of place here */
    #contact-form {
      font-family: "Hind Madurai";
      font-weight: 600;
      font-size: clamp(2.1rem, 4.2vw, 3.6rem);
      line-height: 1.16;
      letter-spacing: -0.6px;
    }
  }
`;

export const Contact = () => {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const isMobile = width <= size.tablet;

	return (
		<StylesWrapper>
			<div className="contact-wrapper">
				<ContactSectionForm
					title={t("contactUs.title")}
					description={t("contactUs.subtitle")}
					isMobile={isMobile}
				/>
			</div>
		</StylesWrapper>
	);
};
